import {
  Box,
  Button,
  Grid,
  Divider,
  Modal,
  Backdrop,
  CircularProgress,
  TextField,
  Card,
  Stack,
  Typography,
  Skeleton,
  IconButton,
} from "@mui/material";
import * as React from "react";
import axios from "axios";
import {
  Dropzone,
  FileMosaic,
  FullScreen,
  ImagePreview,
} from "@files-ui/react";
import OCRDemoDialog from "./OCRDemoDialog";
import InfoIcon from "@mui/icons-material/Info";
import DocumentScannerIcon from "@mui/icons-material/DocumentScanner";
import CloseIcon from "@mui/icons-material/Close";

const OCRModal = ({ state, setOpen, text, setText, token, setOcrImages }) => {
  const [ocrWriting, setOcrWriting] = React.useState("");
  const [uploadImages, setUploadImages] = React.useState([]);
  //const [errorMsg, setErrorMsg] = React.useState("");
  const [loading, setLoading] = React.useState(true);
  const [AILoading, setAILoading] = React.useState(false);
  const [currentUploadIndex, setCurrentUploadIndex] = React.useState(null);
  const [ocrProcessing, setOcrProcessing] = React.useState(false);
  const [openGuideDialog, setOpenGuideDialog] = React.useState(false);

  const [files, setfiles] = React.useState([]);
  const updateFiles = (incommingFiles) => {
    console.log(incommingFiles);
    setfiles(incommingFiles);
    //setfiles(prevfiles => [...prevfiles, ...incommingFiles])
  };
  const removeFile = (id) => {
    setfiles(files.filter((x) => x.id !== id));
  };
  const [imgSrc, setImgSrc] = React.useState(undefined); // for image preview
  const handleSee = (image) => {
    setImgSrc(image);
  };

  React.useEffect(() => {
    console.log("ocrWriting", ocrWriting);
  }, [ocrWriting]);
  //   const [totalFiles, setTotalFiles] = React.useState(
  //     ocrImg.length + files.length
  //   );

  const OCR = async () => {
    //const AuthToken = localStorage.getItem("token");
    //let uploadImagesArray = clone(ocrImg);
    let uploadImagesArray = [];
    let uploadFilesArray = [];
    setAILoading(true);

    /* Image upload */
    let uploadImageName = "temp";
    if (files.length > 0) {
      for (let i = 0; i < files.length; i++) {
        setCurrentUploadIndex(i + 1); // Update the current upload index (1-based)
        uploadImageName = await upLoadImage(files[i]);
        console.log("uploadImageName", uploadImageName);
        uploadImagesArray.push(uploadImageName);
        uploadFilesArray.push(uploadImageName);
      }
    } else {
      alert("Please upload a image.");
      setAILoading(false);
      return;
    }
    setOcrProcessing(true);
    const response = await axios
      .post(
        `${process.env.REACT_APP_API_HOST}/v2/ocr/process`,
        {
          path: "ocr",
          icons: uploadFilesArray,
          //fileType: format,
        },
        { headers: { Authorization: "Bearer " + token } }
      )
      .catch((error) => {
        console.log("OCR error", error);
        setAILoading(false);
        alert("OCR error: " + error);
        return;
      });
    console.log("OCR response", response.data);

    if (response.data) {
      let result = response.data;
      //setOcrWriting(result.text.replace(/\n/g, "") + "\n");
      setOcrWriting(result.text);
    }
    // for (let i = 0; i < uploadFilesArray.length; i++) {
    //   setOcrProcessing(true);
    //   let format =
    //     uploadFilesArray[i] !== "temp"
    //       ? uploadFilesArray[i].split(".").pop().toLowerCase()
    //       : "";

    //   const response = await axios
    //     .post(
    //       `${process.env.REACT_APP_API_HOST}/v2/ocr/process`,
    //       {
    //         path: "ocr",
    //         icon: uploadFilesArray[i],
    //         fileType: format,
    //       },
    //       { headers: { Authorization: "Bearer " + token } }
    //     )
    //     .catch((error) => {
    //       console.log("OCR error", error);
    //       setAILoading(false);
    //       alert("OCR error: " + error);
    //       return;
    //     });
    //   console.log("OCR response", response);

    //   if (response.data.success == "1") {
    //     let no = i + 1;
    //     setOcrWriting(
    //       (prev) =>
    //         prev +
    //         "🔶" +
    //         no +
    //         "\n" +
    //         response.data.ocrResult.document.text +
    //         "\n"
    //     );
    //   }
    // }
    if (uploadImagesArray) {
      setUploadImages(uploadImagesArray);
    }
    setOcrProcessing(false);
    setCurrentUploadIndex(null);
    setAILoading(false);
  };

  const upLoadImage = async (file) => {
    let fs = new FormData();
    fs.append("image", file.file);

    const response = await axios
      .post(`${process.env.REACT_APP_API_HOST}/v2/image/upload/ocrIcon`, fs, {
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": `multipart/form-data`,
        },
      })
      .catch((error) => {
        console.log("upload error", error);
        setAILoading(false);
        alert("upload error: " + error);
        return;
      });
    console.log(response);
    if (response?.data.success) {
      return response.data.name;
    }
  };

  return (
    // <Drawer anchor='bottom' open={state} onClose={toggleDrawer(false)}>
    <Modal open={state}>
      <Grid
        container
        spacing={0}
        justifyContent={"center"}
        sx={{ p: 2 }}
        alignItems={"center"}
      >
        {AILoading && (
          <Backdrop sx={{ color: "#fff", zIndex: 999 }} open={loading}>
            <CircularProgress color="warning" />
            {currentUploadIndex && !ocrProcessing ? (
              <Typography variant="h6" color="warning" sx={{ ml: 2 }}>
                正在處理圖片 {currentUploadIndex} / {files.length}
              </Typography>
            ) : (
              <Typography variant="h6" color="warning" sx={{ ml: 2 }}>
                正在努力轉譯您的圖片，請稍等片刻！
              </Typography>
            )}
          </Backdrop>
        )}
        <Card
          sx={{
            p: { xs: 1, sm: 3 },
            m: { xs: 1, sm: 2 },
            width: { xs: "100%", md: "80%", lg: "60%" },
            overflow: "auto",
            maxHeight: "90vh",
            borderRadius: "20px",
          }}
        >
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            sx={{ width: "100%", mt: 1, mb: 2 }}
          >
            <Stack direction="row" spacing={1} alignItems="center">
              <DocumentScannerIcon />
              <Typography color="text.primary" variant="h5" fontWeight="600">
                OCR 手寫辨識
              </Typography>
            </Stack>
            <Box sx={{ flexGrow: 1 }} />
            <IconButton
              aria-label="close"
              onClick={() => setOpen(false)}
              sx={{
                color: (theme) => theme.palette.grey[900],
              }}
            >
              <CloseIcon />
            </IconButton>
          </Stack>
          <Stack direction="column">
            <Dropzone
              onChange={updateFiles}
              value={files}
              maxFiles={6}
              //disabled={ocrImg?.length + files?.length > 5 ? true : false}
              accept=".jpg, .jpeg, .png"
              label={"拖放或點擊以上傳圖片(最多 6 張圖片)"}
              behaviour="add"
            >
              {files.map((file) => (
                <FileMosaic
                  key={file.id}
                  onDelete={removeFile}
                  {...file}
                  onSee={handleSee}
                  preview
                />
              ))}
            </Dropzone>
            <FullScreen
              open={imgSrc !== undefined}
              onClose={() => setImgSrc(undefined)}
            >
              <ImagePreview src={imgSrc} />
            </FullScreen>
            <Typography
              variant="Body2"
              fontWeight="500"
              sx={{ color: "#303030" }}
            >
              😊請確保圖片中只有清晰的手寫文字，避免拍攝與文章內容無關的部分（像是頁首/頁尾的文字或背景），這樣辨識會更準確！
            </Typography>
            <Typography
              variant="Body2"
              fontWeight="500"
              sx={{ color: "#303030" }}
            >
              ⚠️注意:手寫辨識的準確度會因書寫方式而有所不同，請盡量書寫清晰工整以達至最佳效果。
            </Typography>
            <Button
              variant="outlined"
              color="info"
              startIcon={<InfoIcon />}
              sx={{ mb: 2, alignSelf: "flex-end" }}
              onClick={() => setOpenGuideDialog(true)}
            >
              查看圖片上傳示例
            </Button>
          </Stack>
          <OCRDemoDialog
            open={openGuideDialog}
            onClose={() => setOpenGuideDialog(false)}
          />
          <Stack direction="row" spacing={2} alignItems="center" sx={{ mt: 2 }}>
            <Box sx={{ flexGrow: 1 }} />
            <Button
              variant="contained"
              sx={{
                borderRadius: "10px",
                backgroundColor: "#0071e3",
                width: { xs: "100%", sm: "auto" },
                "&:hover": {
                  backgroundColor: "#0071e3",
                },
              }}
              //disabled={aiCompleted ? true : false}
              onClick={() => {
                OCR();
              }}
            >
              {/* <Trans ns={"passage"} i18nKey={"grading.cancel"} /> */}
              上傳圖片
            </Button>
          </Stack>
          <Divider sx={{ mt: 1, mb: 1, pt: 1, pb: 1 }} />

          {AILoading && (
            <Grid container direction={"row"} spacing={{ xs: 2, md: 3 }}>
              <Grid item xs={12} sm={12}>
                <Skeleton
                  variant="rounded"
                  height={550}
                  sx={{ mt: 2, mb: 0, borderRadius: 5 }}
                  //animation="wave"
                />
              </Grid>
            </Grid>
          )}
          {!AILoading && (
            <>
              <Grid container direction={"column"} spacing={2}>
                <Grid item xs={12}>
                  {ocrWriting !== "" && (
                    <Typography variant="body6" sx={{ mt: 2 }}>
                      請修改作文內容
                      (請依照原文分段，把多行文字合成一行或一段文字)
                    </Typography>
                  )}
                  <TextField
                    multiline
                    label={ocrWriting === "" ? "請上傳圖片" : "請修改作文內容"}
                    rows={20}
                    sx={{
                      mt: 1,
                      mb: 2,
                      backgroundColor: "#F0F0F0",
                      ".MuiInputBase-root": {
                        fontSize: "20px !important",
                        passingBottom: "20px !important",
                      },
                      ".MuiInput-root": {
                        height: " 20px !important",
                      },
                    }}
                    fullWidth
                    disabled={ocrWriting === ""}
                    variant="outlined"
                    value={ocrWriting}
                    //disabled={submitSuccess ? true : false}
                    onChange={(e) => setOcrWriting(e.target.value)}
                  />
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Stack direction="row" spacing={2} alignItems="center">
                  <Box sx={{ flexGrow: 1 }} />
                  <Button
                    variant="contained"
                    sx={{
                      borderRadius: "10px",
                      backgroundColor: "#DB6060",
                    }}
                    onClick={() => {
                      setOpen(false);
                      setOcrWriting("");
                      setUploadImages([]);
                      setfiles([]);
                    }}
                  >
                    清除並關閉
                  </Button>
                  <Button
                    variant="contained"
                    sx={{
                      borderRadius: "10px",
                      backgroundColor: "#0071e3",
                    }}
                    disabled={ocrWriting == ""}
                    onClick={() => {
                      if (ocrWriting !== "") {
                        setText(
                          text !== ""
                            ? text + "-----------------------\n" + ocrWriting
                            : ocrWriting
                        );
                        setOcrImages(uploadImages);
                        setOpen(false);
                      } else {
                        alert("請輸入作文");
                      }
                    }}
                  >
                    保存修改
                  </Button>
                </Stack>
              </Grid>
            </>
          )}
        </Card>
      </Grid>
    </Modal>
  );
};

export default OCRModal;
